import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { AlertBannerComponent } from './alert-banner/alert-banner.component';
import { AlertContainerComponent } from './alert-container/alert-container.component';

@NgModule({
  declarations: [AlertContainerComponent, AlertBannerComponent],
  imports: [CommonModule, MatButtonModule, MatIconModule],
  exports: [AlertContainerComponent, AlertBannerComponent]
})
export class AlertsModule {}
